export const BUFFER_COUNT_DOWN = 30;
export const LINEAR_PROGRESS_INCREASE = Number(
  (100 / BUFFER_COUNT_DOWN).toFixed(2),
);
export const PARTICIPANT_MOVE_BUFFER_TIME = BUFFER_COUNT_DOWN * 1000;

export enum EventUserNotificationType {
  CONFIRM_MOVE = "confirm_move",
  EXECUTE_DELAY_MOVE = "execute_delay_move",
  IMMEDIATE_MOVE = "immediate_move",
}
